// 主人公の歩き 7 版目 (2026-10-13・DEV ?lunaWalk=v7a|v7b) の脚と腰。 配布版は変えない。
//   6 版目 (?lunaWalk=v6a|v6b|v6c) の答え: 一番よい案＝どれも違う・配布版へ＝まだ・重さ＝まだ重い。
//   原文 a「手がずっと前に出てるのが変だなと感じるのかな？手をある程度の位置にしておくのであれば構えてないとおかしいし」、
//   重さ「歩くスピード自体を上げたほうが良い気がする。160だとバタバタしてたから130とかが良いかな？」。
//   記録 = docs/research/2026-10-13-lunaire-walk-v7.md
//
//   速さ 130 (5 版目と 6 版目は 110)。 膝の作り方は 5 版目のまま (床の膝の曲げを鍵にして腰を計算で出す・膝のカクつきが消えた作り)。
//   5 版目の値のまま 130 にすると、1 歩 0.45 秒で歩幅が 58.5px になり、両足が着く所で腰が 11px 沈み、膝が 1 コマ 28° 跳ぶ (測った)。
//   脚の長さは変えられない (絵の差し替えが要る) ので、歩数を少し増やして歩幅の伸びを抑えた:
//     1 歩 0.45 → 0.41 秒 (1 分 133 → 146 歩)・歩幅 49.5 → 53.3px。 着地の位置 20 → 21.5px・片足が床に居る割合 0.57 → 0.55。
//     浮いている足は膝の一番の曲げを 56 → 52° に浅くし、すれ違いの後の伸ばしを少し遅らせる (1 歩が短くなったぶん膝が速く回るので)。
//   腰の上下の幅 2.97px (背丈の 2.5%＝3px が目安)・膝の 1 コマの変化 最大 6.3°・腰の平均は 5 版目より 0.3px 低い。
//
//   このファイルは描画にもゲームの判定にも使う = Spine を import しない (テストから読める)。
import { V5_WALK, type V5Gait } from './player_walk_v5'

/** v7a / v7b: 速さ 130 の歩き (脚と腰は同じ・違いは上半身＝scripts/author_player_walk_v7.ts) */
export const V7_WALK: V5Gait = {
  ...V5_WALK,
  speedPxPerSec: 130,
  stepSec: 0.41,
  stanceFrac: 0.55,
  contactFwdPx: 21.5,
  hipWindow: 0.07,
  swing: [
    { u: 0.25, thigh: 0, knee: 52, pf: 14 },
    { u: 0.48, thigh: 15, knee: 44, pf: 4 },
    { u: 0.72, thigh: 25, knee: 25, pf: -4 },
    { u: 0.9, thigh: 23, knee: 16, pf: -9 },
  ],
}
